import {
  updateResourceState,
  createResourceReducer,
  RESOURCE,
  RECORD_FIELD
} from '@unicus/react-ui-kit';

import {
  PRODUCTMOVEMENT,
  PRODUCTMOVEMENT_DELETE,
  PRODUCTMOVEMENT_DELETE_FINISHED
} from './productMovementActions';

const productMovementReducer = createResourceReducer(PRODUCTMOVEMENT, [], {
  [PRODUCTMOVEMENT_DELETE](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      deleting: true
    }));
  },

  [PRODUCTMOVEMENT_DELETE_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      [RECORD_FIELD]: null,
      saving: false,
      editing: false,
      loaded: false,
      deleting: false
    }));
  }
});

export default productMovementReducer;
